// Set a cookie
export const setCookie = (name: string, value: string) => {
    const now = new Date();
    now.setTime(now.getTime() + (1 * 60 * 60 * 1000)); // 1 hour in milliseconds
    let expires = now.toUTCString();
    try {
        var obj = JSON.parse(value);
        if (obj.cart && obj.cart.length > 0) {
            for (var i = 0; i < obj.cart.length; i++) {
                if (obj.cart[i] && obj.cart[i].name) {
                    try {
                        obj.cart[i].name = (btoa(encodeURI(obj.cart[i].name)));
                    } catch (err) {
                        console.log(err, obj.cart[i]);
                    }
                } else {
                    obj.cart.splice(obj.cart[i], 1);
                    i--;
                }
            }
        }
        value = obj;
    } catch (err) {
        console.log(err);
    }
    if (name === 'sessionDetails') {
        expires = "; expires=" + expires;
    } else {
        expires = ";expires=Thu, 01 Jan 2060 00:00:01 GMT"
    }
    if (window.location.hostname === 'localhost') {
        document.cookie = name + '=' + JSON.stringify(value) + '; expires=' + expires + ';path=/';
    } else {
        document.cookie = name + '=' + JSON.stringify(value) + '; expires=' + expires + ';domain=.nvidia.com;path=/;secure';
    }
}

// Get a cookie
export const getCookie = (cname: string) => {
    var _state;
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            _state = c.substring(name.length, c.length);
        }
    }

    if (cname === 'nvHeadless' && _state && _state !== undefined) {
        try {
            var obj = JSON.parse(_state);
            if (obj.cart && obj.cart.length > 0) {
                for (var i = 0; i < obj.cart.length; i++) {
                    if (obj.cart[i] && obj.cart[i].name) {
                        try {
                            obj.cart[i].name = (decodeURI(atob(obj.cart[i].name)));
                        } catch (err) {
                            console.log(err, obj.cart[i]);
                        }
                    } else {
                        obj.cart.splice(obj.cart[i], 1);
                        i--;
                    }
                }
            }
            _state = obj;
        } catch (err) {
            console.error(err);
        }
    }
    return _state;
}

// Remove a cookie
export const removeCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

